import { motion } from "framer-motion";
import { LASERCUT } from "@/constants/testIds";

const CHAPTERS = [
  {
    n: "01",
    title: "Presisi CNC",
    body:
      "Setiap potongan lahir dari mesin laser & plasma cutting yang mengukir plat besi dengan akurasi milimeter — tanpa kompromi pada detail motif sekecil apapun.",
  },
  {
    n: "02",
    title: "Estetika Ukiran",
    body:
      "Motif geometris, lengkung Neo Deco, hingga kaligrafi personal — kami menerjemahkan ide Anda menjadi ornamen logam yang bercerita, bukan sekadar plat berlubang.",
  },
  {
    n: "03",
    title: "Finishing Tahan Cuaca",
    body:
      "Powder coating premium melindungi setiap karya dari hujan, panas, dan garam udara — warna tetap tajam, struktur tetap kokoh, bertahun-tahun ke depan.",
  },
  {
    n: "04",
    title: "Proses End-to-End",
    body:
      "Dari konsultasi kebutuhan, desain, cutting, pengelasan, hingga instalasi di lokasi — satu bengkel, satu tanggung jawab penuh atas kualitas hasil akhir.",
  },
];

export const Manifesto = () => (
  <section id="tentang" className="relative bg-ink py-24 md:py-36 px-6 md:px-12 lg:px-24">
    <div className="max-w-3xl mb-16 md:mb-24">
      <span className="text-xs uppercase tracking-[0.25em] text-brass">Tentang Kami</span>
      <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl tracking-tight leading-tight text-chromed mt-4">
        Bengkel fabrikasi yang mengubah plat besi mentah menjadi karya presisi bernilai desain tinggi.
      </h2>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-14">
      {CHAPTERS.map((c, i) => (
        <motion.div
          key={c.n}
          data-testid={LASERCUT.manifestoChapter(c.n)}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: (i % 2) * 0.15 }}
          className="border-t border-linecol pt-8"
        >
          <span className="font-heading text-5xl md:text-6xl text-brass/80">{c.n}</span>
          <h3 className="font-heading text-2xl md:text-3xl text-chromed mt-4 mb-3">{c.title}</h3>
          <p className="text-chromed/60 leading-relaxed max-w-md">{c.body}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
